import { type CalendarEvent } from "@fitness-app/data-models/domain/services/ProgramService";

import { CalendarChip, CalendarChipPreview } from "~/components/EventCalendar/CalendarChip";
import { type RenderEventOptions } from "~/components/EventCalendar/calendarModel";
import CustomEventCell from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeCalendar/components/CustomEventCell";
import { getEventKey, getEventTone, isDraggableEvent } from "./traineeCalendarEvents";

// Treść chipa rysuje CustomEventCell (ikonka + popover ze szczegółami).
interface CalendarEventChipProps extends Partial<RenderEventOptions> {
  event: CalendarEvent;
  onClick?: (event: CalendarEvent) => void;
}

export const CalendarEventChip = ({ event, draggable = true, dragIdScope, onClick }: CalendarEventChipProps) => (
  <CalendarChip
    dragId={dragIdScope ? `${dragIdScope}:${getEventKey(event)}` : getEventKey(event)}
    dragData={{ event }}
    canDrag={draggable && isDraggableEvent(event)}
    toneClassName={getEventTone(event)}
    onClick={() => onClick?.(event)}
  >
    <CustomEventCell event={event} />
  </CalendarChip>
);

export const CalendarEventChipPreview = ({ event }: { event: CalendarEvent }) => (
  <CalendarChipPreview toneClassName={getEventTone(event)}>
    <CustomEventCell event={event} />
  </CalendarChipPreview>
);
